import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * Act Sync FTC save service.
 * Original AngularJS: actSyncFtcServiceFactory.saveActSyncFtcData, action_code=aiw7ss
 *
 * Payload parity: merge(isIssueIDEnabled, globalParams, clob_settings, clob_data).
 * isIssueIDEnabled (scenarioCode, is_issue_key_enabled) is pre-computed in AngularJS
 * controller and passed via filterParams.
 */
@Injectable({
  providedIn: 'root'
})
export class ActSyncFtcService {

  constructor(private http: HttpClient) {}

  saveActSyncFtcData(
    baseUrl: string,
    formData: { dropdown?: string; fromChartKey?: string; sysActKey?: string; gieKey?: string },
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=aiw7ss';
    const jsonObj = formData;
    const jsonSettings = globalService?.globalParams || globalService || {};
    const globalParams = globalService?.globalParams || globalService || {};

    // Match AngularJS: params = _.merge(isIssueIDEnabled, globalParams, { clob_settings, clob_data })
    // isIssueIDEnabled result (scenarioCode, is_issue_key_enabled) is passed via filterParams by AngularJS controller
    const issueIdObj = {
      scenarioCode: filterParams?.scenarioCode || filterParams?.scenario_code || globalParams?.scenarioCode || 'RAF',
      is_issue_key_enabled: filterParams?.is_issue_key_enabled || globalParams?.is_issue_key_enabled || 'N'
    };
    const params: any = _.merge({}, issueIdObj, globalParams, {
      clob_settings: JSON.stringify(jsonSettings),
      clob_data: JSON.stringify(jsonObj)
    });

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
